import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";

function CustomerOrdersPage() {
  const customer = useSelector((store) => store.customer);
  const [orders, setOrders] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  try {
    const getOrders = async () => {
      const response = await axios({
        method: "GET",
        url: process.env.REACT_APP_API_URL + `/api/orders`,
        headers: { Authorization: `Bearer ${customer.access_token}` },
      });
      setOrders(response.data);
    };

    useEffect(() => {
      getOrders();
    }, []);
  } catch (error) {
    console.log("Error: ", error);
  }

  return orders.length > 0 ? (
    <div className="container py-sm-5 orders-container animate__animated animate__fadeIn">
      <h1 className="h2 my-3">My orders</h1>
      <div className="table-responsive">
        <table className="table table-hover align-middle mt-4 border text-responsive">
          <thead className="bg-yellow text-white">
            <tr>
              <th scope="col">#</th>
              <th scope="col">Products</th>
              <th scope="col">Units</th>
              <th scope="col">Status</th>
              <th scope="col">Date</th>
              <th scope="col">Total Price</th>
            </tr>
          </thead>
          <tbody>
            {orders.map((order, i) => (
              <tr
                key={order.id}
                className="f-roboto border pointer"
                onClick={() =>
                  navigate(
                    `/customers/${customer.firstname.toLowerCase()}/orders/${
                      order.id
                    }`
                  )
                }
              >
                <th scope="row" className="border bg-light">
                  {i + 1}
                </th>
                <td>
                  {order.products.length}{" "}
                  {order.products.length === 1 ? "product" : "products"}
                </td>
                <td>
                  {order.products.reduce(
                    (acc, product) => acc + product.qty,
                    0
                  )}
                </td>
                <td>{order.status}</td>
                <td>{new Date(order.createdAt).toLocaleDateString()}</td>
                <td>{`$${(order.totalAmount * 1).toFixed(2)}`}</td>
                {/* <td>${order.totalAmount}</td> */}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  ) : (
    <div className="py-5 my-5">
      <p className="h3 py-5 my-5 text-center">You have no orders</p>
    </div>
  );
}

export default CustomerOrdersPage;
